import { FC } from "react";

type ChevronProps = {
  isOpen: boolean;
  fill?: string;
  size?: number;
};

const Chevron: FC<ChevronProps> = ({ isOpen, fill = "black", size = 20 }) => {
  return (
    <>
      <svg
        className={`min-w-${size}px ${!isOpen ? "rotate-180" : "rotate-0"}`}
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.38161 11.6175C2.89464 12.1045 2.89464 12.894 3.38161 13.3809C3.8682 13.8675 4.65699 13.868 5.14411 13.3819L9.99988 8.53672L14.8556 13.3819C15.3428 13.868 16.1316 13.8675 16.6181 13.3809C17.1051 12.894 17.1051 12.1045 16.6181 11.6175L11.4141 6.41343C10.633 5.63238 9.36671 5.63238 8.58566 6.41343L3.38161 11.6175Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default Chevron;
